// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "static/chunks/954-28307b478d9e25c1.js";
	if (chunkId === 258) return "static/chunks/258-e4b07f9e451d77ea.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"5c3e8134364179f7","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"4d276d8a4864f10c","367":"1ad0ed67a542ece9","639":"cf9d73bb0d566e4a","748":"439a11a6be81cc7e"}[chunkId] + ".js";
};